module.exports = __webpack_public_path__ + "img/pic-2.f88d2572.png";